module.exports = __webpack_public_path__ + "img/schedule_1.8cf42401.png";